export default __webpack_public_path__ + "static/media/noun_growth_3785236.51972a13.svg";